import React from 'react';
import { FilePreview } from '@/Components/shared';
import { Question, QuestionType } from '../../../../../../../../Models/Questions';
import HtmlViewer from './QuestionComponents/HtmlViewer';
import useText from './hardcode/useText';
import { RadioGroup, RadioGroupItem } from '@/Components/shadcn/radio-group';
import { Label } from '@/Components/shadcn/label';
import { Input } from '@/Components/shadcn/input';
import { TypographyH4 } from '@/Components/shadcn';

interface AnswerQuestionsPreviewProps {
    demoQuestion: Question;
}

const AnswerQuestionsPreview = ({ demoQuestion }: AnswerQuestionsPreviewProps): React.JSX.Element => {
    const UIStrings = useText();

    return (
        <div className="grid h-full min-h-0 grid-cols-1 gap-6 overflow-auto p-6 lg:grid-cols-2">
            <div className="flex min-h-0 flex-col gap-2">
                <div className="flex flex-row items-end gap-2">
                    <TypographyH4 className="text-primary text-xl font-semibold">{UIStrings.Question}</TypographyH4>
                </div>
                <div className="min-h-0">
                    <HtmlViewer html={demoQuestion.question} />
                </div>
                <FilePreview src={demoQuestion.blobFileURI} fileMimeType={demoQuestion.fileMimeType} />
            </div>
            <div className="flex min-h-0 flex-col gap-2">
                <TypographyH4 className="text-primary text-xl font-semibold">{UIStrings.Answer}</TypographyH4>
                <p className="text-foreground text-lg font-medium">
                    {demoQuestion.questionType === QuestionType.Choice && UIStrings.ChooseAnswers}
                    {demoQuestion.questionType === QuestionType.Exact && UIStrings.EnterAnswer}
                </p>
                <div className="flex flex-col items-start gap-3">
                    {demoQuestion.questionType === QuestionType.Choice && (
                        <RadioGroup value="" onValueChange={() => {}} className="pointer-events-none w-full gap-4">
                            {demoQuestion.answers.map((answer) => (
                                <div key={answer.id} className="flex items-start gap-3">
                                    <RadioGroupItem
                                        value={String(answer.id)}
                                        id={`answer-${answer.id}`}
                                        className="mt-1"
                                    />
                                    <Label htmlFor={`answer-${answer.id}`} className="text-foreground font-normal">
                                        <HtmlViewer html={answer.content} />
                                    </Label>
                                </div>
                            ))}
                        </RadioGroup>
                    )}
                    {demoQuestion.questionType === QuestionType.Exact && (
                        <Input readOnly disabled className="max-w-md" value="" placeholder="" />
                    )}
                </div>
            </div>
        </div>
    );
};

export default AnswerQuestionsPreview;
